import React, { forwardRef } from 'react';
const AvatarGroup = (StyledAvatarGroup) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAvatarGroup ref={ref} {...props}>
        {[...children].flat(Infinity).reverse()}
      </StyledAvatarGroup>);
});
export default AvatarGroup;
